import React, { useState, useEffect } from 'react'
import { $api } from './api'

const UserCounter = () => {
  const [count, setCount] = useState(0)

  // User Data
  useEffect(() => {
    const userCount = async () => {
      await $api.get('/users').then(response => {
        setCount(response.data.length)
      })
    }
    userCount()

    return () => {
      setCount(0)
    }
  }, [])

  return <div>{count}</div>
}

export default UserCounter
